/**
 * Contexte « le loader général voile cette zone ».
 *
 * @remarks
 * Le voile du loader général (`app/layout/GlobalLoader`) couvre le panneau
 * central pendant le premier chargement d'une donnée. Les loaders locaux
 * (`LoadingState`, `Skeleton`) qui s'y trouveraient feraient doublon : ils
 * lisent ce contexte et se rendent invisibles (même taille, pas de saut de
 * mise en page) tant que le voile est visible. Hors de la zone centrale
 * (panneaux latéraux, pages d'auth), le contexte vaut `false` : rien ne change.
 */

import { createContext, useContext } from 'react';

export const LoaderVeilContext = createContext(false);

/** `true` quand le loader général est visible au-dessus de la zone courante. */
export function useIsVeiled(): boolean {
  return useContext(LoaderVeilContext);
}
